import { Card, CardBody, Text } from '@chakra-ui/react'
import React from 'react'

const NoItemsAvailableCard = () => {
  return (
    <Card border='none' boxShadow='none'>
      <CardBody>
        <Text align='center' color='#315B84'>
          No item available
        </Text>
      </CardBody>
    </Card>
  )
}

export default NoItemsAvailableCard